import axios from 'axios';
import { ApiResponse, NhomThucHanh } from '../../../shared/types';

const API_BASE = '/api/v1/nhom-thuc-hanh';

interface GetGroupsParams {
  khoaHocId?: string;
  monHocId?: string;
  lopHocId?: string;
}

class NhomThucHanhService {
  async getPracticeGroups(params: GetGroupsParams): Promise<ApiResponse<NhomThucHanh[]>> {
    const response = await axios.get<ApiResponse<NhomThucHanh[]>>(`${API_BASE}`, { params });
    return response.data;
  }
  
  async createBatch(data: {
    groups: any[];
    lopHocId: string;
    khoaHocId: string;
    monHocId: string;
  }): Promise<ApiResponse> {
    const response = await axios.post<ApiResponse>(`${API_BASE}/create-batch`, data);
    return response.data;
  }

  async getGroupStudents(groupId: string): Promise<ApiResponse<any[]>> {
    const response = await axios.get<ApiResponse<any[]>>(`${API_BASE}/${groupId}/sinhvien`);
    return response.data;
  }

  async updateGroupStudents(groupId: string, maHSList: string[]): Promise<ApiResponse> {
    const response = await axios.post<ApiResponse>(`${API_BASE}/${groupId}/sinhvien`, { maHSList });
    return response.data;
  }

  async getStudentsInGroup(groupId: string): Promise<ApiResponse<any[]>> {
    const response = await axios.get<ApiResponse<any[]>>(`${API_BASE}/${groupId}/students`);
    return response.data;
  }

  async getAvailableStudents(lopHocId: string, monHocId: string): Promise<ApiResponse<any[]>> {
    const response = await axios.get<ApiResponse<any[]>>(`${API_BASE}/available-students/${lopHocId}/${monHocId}`);
    return response.data;
  }

  async updateStudentsInGroup(groupId: string, maHSList: string[]): Promise<ApiResponse> {
    const response = await axios.post<ApiResponse>(`${API_BASE}/${groupId}/students`, { maHSList });
    return response.data;
  }

  async deleteGroup(groupId: string): Promise<ApiResponse> {
    const response = await axios.delete<ApiResponse>(`${API_BASE}/${groupId}`);
    return response.data;
  }

  async updateGroup(groupId: string, data: Partial<NhomThucHanh>): Promise<ApiResponse> {
    const response = await axios.put<ApiResponse>(`${API_BASE}/${groupId}`, data);
    return response.data;
  }
}

export default new NhomThucHanhService(); 